<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'mapping-banner'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="mapping-banner-head-label">
        Banner List
      </div>
    </template>
    <b-row class="modal-body-container mb-1">
      <b-col
        cols="12"
        class="pd-mapping-search mb-2"
      >
        <search
          :on-search-input="onSearchBanner"
          class="mapping-search"
        />
      </b-col>
      <b-col cols="12">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="setMappingBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="set-mapping-table-modal"
            >
              <template #cell(banner_image_image_url)="data">
                <div
                  v-if="data.item.banner_image_image_url"
                  class="col-img"
                >
                  <img
                    class="h-100"
                    :src="data.item.banner_image_image_url"
                    alt=""
                    draggable="false"
                  >
                </div>
                <div v-else>
                  -
                </div>
              </template>
              <template #cell(call_to_action)="data">
                <span>{{ resolveCallToAction(data.item.call_to_action) }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status == 1"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />
                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <add-banner-button
                  btn-label="Add Banner"
                  :disabled="data.item.mapping"
                  @click.native="addMappingBanner(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
  </base-modal>
</template>
<script>
import BaseModal from '@core/components/base-modal/BaseModal.vue'
import {
  BRow, BCol, BButton, BTable, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Search from '@/views/components/search/Search.vue'
import AddBannerButton from '@/views/components/button/AddBannerButton.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useMappingBannerModal from '../hooks/useMappingBannerModal'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    vSelect,
    BaseModal,
    Search,
    BTable,
    AddBannerButton,
    BSpinner,
    CardNoItem,
    PaginationWithReorder,
  },
  props: {
    isSet: Boolean,
    mappingList: Object,
    displayKey: String,
    queryDataKey: String,
    queryId: Number,
  },
  setup(props) {
    const {
      fields,
      setMappingBannerTable,
      pagination,
      loading,
      addedMappingBannerList,
      resolveBannerStatusLabel,
      resolveCallToAction,
      addMappingBanner,
      onPageChange,
      onSearchBanner,
      onModalOpen,
    } = useMappingBannerModal(props)

    const resolveCssVariables = () => {
      const cssVariables = this.$store.getters['appConfig/cssVariables']
      return cssVariables
    }

    return {
      fields,
      setMappingBannerTable,
      pagination,
      loading,
      addedMappingBannerList,
      resolveBannerStatusLabel,
      resolveCallToAction,
      resolveCssVariables,
      addMappingBanner,
      onPageChange,
      onSearchBanner,
      onModalOpen,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/banner/mapping-banner-modal.css';
@import '~@/assets/css/pages/banner/set-banner.css';
@import '~@/assets/css/override-styles/status.css';
</style>
